export default {
  // Tab names
  'tab.main': '메인',
  'tab.producers': '생산기',
  'tab.achievements': '업적',
  'tab.prestige': '환생',
  'tab.settings': '설정',

  // Header
  'header.bps': '/초',
  'header.stage': '단계',
  'header.tap': 'TAP!',

  // Combo
  'combo.nice': 'Nice!',
  'combo.great': 'Great!',
  'combo.amazing': 'Amazing!',
  'combo.incredible': 'INCREDIBLE!',
  'combo.legendary': 'LEGENDARY!',
  'combo.label': '콤보',

  // Critical
  'crit.label': 'CRITICAL!',

  // Producers
  'producer.P1': '씨앗',
  'producer.P2': '새싹',
  'producer.P3': '묘목',
  'producer.P4': '커피나무',
  'producer.P5': '소규모 농장',
  'producer.P6': '대규모 농장',
  'producer.P7': '로스터리',
  'producer.P8': '커피 공장',
  'producer.P9': '수출 허브',
  'producer.P10': '프랜차이즈',
  'producer.P11': '커피 제국',
  'producer.P12': '커피 행성',

  // Tap upgrades
  'upgrade.T1': '빠른 손가락',
  'upgrade.T2': '장갑',
  'upgrade.T3': '도구',
  'upgrade.T4': '기계',
  'upgrade.T5': '로봇',
  'upgrade.T6': '나노 기술',
  'upgrade.T7': '양자 수확',
  'upgrade.T8': '시간 왜곡',

  // Prestige upgrades
  'prestige.G1': '황금 씨앗',
  'prestige.G1.desc': 'BPS +1 기본',
  'prestige.G2': '비옥한 토양',
  'prestige.G2.desc': '탭 파워 x1.5',
  'prestige.G3': '초보자 할인',
  'prestige.G3.desc': 'P1~P3 비용 -50%',
  'prestige.G4': '밤새 성장',
  'prestige.G4.desc': '오프라인 효율 +20%',
  'prestige.G5': '속성 재배',
  'prestige.G5.desc': '전체 BPS x2',
  'prestige.G6': '행운의 손',
  'prestige.G6.desc': '크리티컬 확률 +3%',
  'prestige.G7': '마스터 바리스타',
  'prestige.G7.desc': '탭 파워 x3',
  'prestige.G8': '도매 할인',
  'prestige.G8.desc': '전체 비용 -20%',
  'prestige.G9': '빠른 시작',
  'prestige.G9.desc': 'P1~P3 10개로 시작',
  'prestige.G10': '프리미엄 블렌드',
  'prestige.G10.desc': '전체 BPS x3',
  'prestige.G11': '시간의 원두',
  'prestige.G11.desc': '오프라인 효율 100%',
  'prestige.G12': '커피 왕의 왕관',
  'prestige.G12.desc': '전체 생산 x2',
  'prestige.G13': '골든빈 나무',
  'prestige.G13.desc': '골든빈 획득 +20%',
  'prestige.G14': '시간 여행',
  'prestige.G14.desc': '5단계에서 시작',
  'prestige.G15': '무한의 원두',
  'prestige.G15.desc': '전체 생산 x10',
  'prestige.G16': '커피 빅뱅',
  'prestige.G16.desc': '골든빈 획득 x2',

  // Star upgrades
  'star.S1': '시작 자금',
  'star.S1.desc': '시작 시 100만 콩',
  'star.S2': '영원한 황금',
  'star.S2.desc': '골든빈 획득 x2 영구',
  'star.S3': '별의 축복',
  'star.S3.desc': '전체 BPS x5 영구',
  'star.S4': '자동 탭',
  'star.S4.desc': '초당 1회 자동 탭',
  'star.S5': '콤보 마스터',
  'star.S5.desc': '콤보 유지 시간 3초',
  'star.S6': '치명적 일격',
  'star.S6.desc': '크리티컬 배율 x2',
  'star.S7': '우주의 힘',
  'star.S7.desc': '전체 생산 x10 영구',
  'star.S8': '초월의 별',
  'star.S8.desc': '승천 보너스 x3',

  // Varieties
  'variety.V1': '아라비카',
  'variety.V2': '로부스타',
  'variety.V3': '리베리카',
  'variety.V4': '엑셀사',
  'variety.V5': '게이샤',
  'variety.V6': '코피 루왁',
  'variety.V7': '블루 마운틴',
  'variety.V8': '코나',
  'variety.V9': '이르가체페',
  'variety.V10': '피베리',
  'variety.V11': '마라고지페',
  'variety.V12': '세인트 헬레나',

  // Stages
  'stage.1': '할머니의 정원',
  'stage.2': '작은 마당',
  'stage.3': '커피 농장',
  'stage.4': '로스터리',
  'stage.5': '커피 공장',
  'stage.6': '글로벌 체인',
  'stage.7': '커피 왕국',

  // Roasting
  'roast.perfect': '완벽한 로스팅!',
  'roast.dark': '다크 로스트',
  'roast.medium': '미디엄 로스트',
  'roast.light': '라이트 로스트',
  'roast.burnt': '타버렸다...',
  'roast.raw': '덜 익었다',
  'roast.tap': '탭해서 멈추기!',
  'roast.reward': '보상',
  'roast.double': '광고 보고 2배!',
  'roast.collect': '수령',

  // Achievements
  'ach.tap1': '첫 발걸음', 'ach.tap1.desc': '100번 탭',
  'ach.tap2': '부지런한 손', 'ach.tap2.desc': '1,000번 탭',
  'ach.tap3': '탭 마스터', 'ach.tap3.desc': '10,000번 탭',
  'ach.tap4': '전설의 손가락', 'ach.tap4.desc': '100,000번 탭',
  'ach.tap5': '탭의 신', 'ach.tap5.desc': '1,000,000번 탭',
  'ach.tap6': '빠른 손', 'ach.tap6.desc': '초당 5회 탭',
  'ach.tap7': '번개 손', 'ach.tap7.desc': '초당 10회 탭',
  'ach.tap8': '신의 손', 'ach.tap8.desc': '초당 15회 탭',
  'ach.tap9': '콤보 마니아', 'ach.tap9.desc': '20 콤보 달성',
  'ach.tap10': '전설의 콤보', 'ach.tap10.desc': '50 콤보 달성',

  'ach.prod1': '첫 수확', 'ach.prod1.desc': '총 1천 콩 수확',
  'ach.prod2': '작은 성과', 'ach.prod2.desc': '총 10만 콩 수확',
  'ach.prod3': '성장하는 농장', 'ach.prod3.desc': '총 1천만 콩 수확',
  'ach.prod4': '커피 거물', 'ach.prod4.desc': '총 10억 콩 수확',
  'ach.prod5': '커피 황제', 'ach.prod5.desc': '총 1조 콩 수확',
  'ach.prod6': '자동화 시작', 'ach.prod6.desc': 'BPS 100 도달',
  'ach.prod7': '공장 가동', 'ach.prod7.desc': 'BPS 1만 도달',
  'ach.prod8': '산업 혁명', 'ach.prod8.desc': 'BPS 100만 도달',
  'ach.prod9': '글로벌 생산', 'ach.prod9.desc': 'BPS 1억 도달',
  'ach.prod10': '우주적 생산', 'ach.prod10.desc': 'BPS 100억 도달',

  'ach.bld1': '초보 농부', 'ach.bld1.desc': 'P1~P4 각 1개 보유',
  'ach.bld2': '중급 농부', 'ach.bld2.desc': 'P1~P8 각 1개 보유',
  'ach.bld3': '마스터 농부', 'ach.bld3.desc': '모든 생산기 보유',
  'ach.bld4': '집중 투자', 'ach.bld4.desc': '한 종류 10개 보유',
  'ach.bld5': '대량 구매', 'ach.bld5.desc': '한 종류 25개 보유',
  'ach.bld6': '컬렉터', 'ach.bld6.desc': '한 종류 50개 보유',
  'ach.bld7': '독점왕', 'ach.bld7.desc': '한 종류 100개 보유',
  'ach.bld8': '사업 확장', 'ach.bld8.desc': '총 100개 생산기',
  'ach.bld9': '기업 제국', 'ach.bld9.desc': '총 500개 생산기',
  'ach.bld10': '세계 지배', 'ach.bld10.desc': '총 1000개 생산기',

  'ach.pres1': '첫 환생', 'ach.pres1.desc': '1회 환생',
  'ach.pres2': '반복의 맛', 'ach.pres2.desc': '3회 환생',
  'ach.pres3': '환생 마스터', 'ach.pres3.desc': '5회 환생',
  'ach.pres4': '끝없는 순환', 'ach.pres4.desc': '10회 환생',
  'ach.pres5': '영원의 고리', 'ach.pres5.desc': '20회 환생',
  'ach.pres6': '윤회의 달인', 'ach.pres6.desc': '50회 환생',
  'ach.pres7': '황금 수확', 'ach.pres7.desc': '한 번에 10 골든빈',
  'ach.pres8': '황금 폭풍', 'ach.pres8.desc': '한 번에 100 골든빈',
  'ach.pres9': '스피드러너', 'ach.pres9.desc': '30분 내 환생',
  'ach.pres10': '번개 환생', 'ach.pres10.desc': '15분 내 환생',

  'ach.spec1': '체리 헌터', 'ach.spec1.desc': '골든 체리 1회 탭',
  'ach.spec2': '체리 마니아', 'ach.spec2.desc': '골든 체리 10회 탭',
  'ach.spec3': '체리 마스터', 'ach.spec3.desc': '골든 체리 50회 탭',
  'ach.spec4': '로스팅 입문', 'ach.spec4.desc': '퍼펙트 로스팅 1회',
  'ach.spec5': '로스팅 달인', 'ach.spec5.desc': '퍼펙트 로스팅 10회',
  'ach.spec6': '품종 수집가', 'ach.spec6.desc': '5가지 품종 수집',
  'ach.spec7': '커피 박사', 'ach.spec7.desc': '12가지 품종 전부 수집',
  'ach.spec8': '꾸준한 농부', 'ach.spec8.desc': '총 1시간 플레이',
  'ach.spec9': '커피 중독', 'ach.spec9.desc': '총 24시간 플레이',
  'ach.spec10': '7일 연속', 'ach.spec10.desc': '7일 연속 접속',

  'ach.mile1': '커피 농장주', 'ach.mile1.desc': '3단계 도달',
  'ach.mile2': '커피 사업가', 'ach.mile2.desc': '5단계 도달',
  'ach.mile3': '커피 왕', 'ach.mile3.desc': '7단계 도달',
  'ach.mile4': '초월자', 'ach.mile4.desc': '첫 별 승천',
  'ach.mile5': '완벽주의자', 'ach.mile5.desc': '50개 업적 달성',

  // Achievement categories
  'ach.cat.tapping': '탭',
  'ach.cat.production': '생산',
  'ach.cat.producers': '생산기',
  'ach.cat.prestige': '환생',
  'ach.cat.special': '특수',
  'ach.cat.milestone': '마일스톤',

  // Prestige panel
  'prestige.title': '로스트 환생',
  'prestige.desc': '환생하면 골든빈을 얻고 처음부터 더 강하게!',
  'prestige.goldenBeans': '골든빈',
  'prestige.expected': '예상 획득',
  'prestige.rebirth': '환생',
  'prestige.upgrades': '환생 업그레이드',
  'prestige.locked': '7단계 도달 시 해금',
  'prestige.adBonus': '광고 보고 +30%',

  // Ascension panel
  'ascend.title': '별의 승천',
  'ascend.desc': '승천하면 별의 먼지를 얻고 모든 것을 초월!',
  'ascend.starDust': '별의 먼지',
  'ascend.expected': '예상 획득',
  'ascend.ascend': '승천',
  'ascend.upgrades': '별 업그레이드',
  'ascend.locked': '환생 10회 + 골든빈 100개 필요',

  // Settings
  'settings.bgm': '배경 음악',
  'settings.sfx': '효과음',
  'settings.vibration': '진동',
  'settings.language': '언어',
  'settings.reset': '데이터 초기화',
  'settings.resetConfirm': '정말 모든 데이터를 삭제하시겠습니까?',
  'settings.credits': '크레딧',
  'settings.version': '버전',

  // Boost buttons
  'boost.tap': '탭 부스트',
  'boost.bps': '생산 부스트',

  // Offline
  'offline.title': '다시 오셨군요!',
  'offline.earned': '오프라인 수익',
  'offline.time': '떠난 시간',
  'offline.collect': '수령',
  'offline.adX3': '광고 보고 x3',

  // General
  'buy': '구매',
  'max': '최대',
  'level': 'Lv.',
  'locked': '잠김',
  'owned': '보유',
  'on': '켜기',
  'off': '끄기',
} as const;
